"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSET_CDN_DOMAIN = void 0;
exports.ASSET_CDN_DOMAIN = {
    local: 'localhost',
    dev: 'frontends-dev.udemycdn.com',
    prod: 'frontends.udemycdn.com',
};
//# sourceMappingURL=next.config.env.js.map